import React, { useEffect, useState } from "react";
import MainPiecesBox from "../MainPiecesBox/MainPiecesBox";
import MainPieceDesc from "../MainPiecesDesc/MainPieceDesc";
import MainTermsBox from "../MainTermsBox.js/MainTermsBox";
import MainSecTwoMobile from "./MainSecTwoMobile";
import {
  PIECES_LONG,
  PIECES_MID,
  PIECES_SHORT,
  PIECES_TERMS,
} from "../../../constants/pieceItems";

/**
 * MainSecTwo component displays a section containing selectable pieces,
 * their descriptions, and terms. It manages the state of selected terms
 * and pieces, and updates the displayed piece based on the selected term.
 *
 * @component
 * @example
 * return (
 *   <MainSecTwo />
 * )
 */

export default function MainSecTwo() {
  const [pieceItems, setPieceItems] = useState([]);
  const [piecesTerms, setPiecesTerms] = useState([]);
  const [pieceNameFA, setPieceNameFA] = useState("");
  const [animIndex, setAnimIndex] = useState(0);
  const [termsIndex, setTermsIndex] = useState(0);

  // Effect to update the piece name based on the animated index
  useEffect(() => {
    setPieceNameFA(pieceItems.find((item) => item.id === animIndex)?.pieceName);
  }, [animIndex]);

  // Effect to set initial piece items and terms
  useEffect(() => {
    setPieceItems(PIECES_SHORT);
    setPiecesTerms(PIECES_TERMS);
  }, []);

  // Effect to handle term selection and update pieces accordingly
  useEffect(() => {
    var tempTerms = [];
    piecesTerms.forEach((item) => {
      if (item.id == termsIndex) {
        item.isSelect = true;
      } else {
        item.isSelect = false;
      }
      tempTerms.push(item);
    });
    if (tempTerms.length !== 0) {
      setPiecesTerms(tempTerms);
    }

    switch (termsIndex) {
      case 1: {
        setAnimIndex(0);
        setPieceItems(PIECES_SHORT);
        break;
      }
      case 2: {
        setAnimIndex(0);
        setPieceItems(PIECES_MID);
        break;
      }
      case 3: {
        setAnimIndex(0);
        setPieceItems(PIECES_LONG);
        break;
      }
    }
  }, [termsIndex]);

  return (
    <div className=" w-full h-full flex items-center justify-center ">
      <div className="w-full max-w-[1440px] hidden min-[769px]:flex flex-col items-center justify-center mt-[40px]">
        <div className="w-full flex justify-center items-center">
          {/* Left Circle Segment */}
          <div className="relative ">
            <img
              src="../assets/images/mainPage/img_circleSigmentsLeft.svg"
              className="w-[180px] h-[623px] "
            />

            {piecesTerms.map((item) => (
              <MainTermsBox
                id={item.id}
                key={item.id}
                src={item.src}
                top={item.top}
                right={item.right}
                termsName={item.termsName}
                isSelect={item.isSelect}
                setTermsIndex={setTermsIndex}
              />
            ))}
          </div>

          {/* Main Piece Section */}
          <div className="relative flex h-[623px] flex-col items-center justify-center">
            <img
              src="../assets/images/mainPage/img_mainCar.png"
              className="w-[485px] h-[199px] "
            />
            {pieceItems.map((item) => (
              <MainPieceDesc
                key={item.id}
                pieceItems={pieceItems}
                desc={item.desc}
                animIndex={animIndex}
                setAnimIndex={setAnimIndex}
              />
            ))}
          </div>

          {/* Right Circle Segment */}
          <div className="relative">
            <img
              src="../assets/images/mainPage/img_circleSigmentsRight.svg"
              className="w-[180px] h-[623px] "
            />

            {/* Small circles for visual representation */}
            <div className="absolute top-[10px] left-[15px] w-[5px] h-[5px] bg-color-primary-D rounded-full"></div>
            <div className="absolute top-[16px] left-[25px] w-[5px] h-[5px] bg-color-primary-D rounded-full"></div>
            <div className="absolute top-[22px] left-[35px] w-[5px] h-[5px] bg-color-primary-D rounded-full"></div>
            <div className="absolute bottom-[10px] left-[20px] w-[5px] h-[5px] bg-color-primary-D rounded-full"></div>
            <div className="absolute bottom-[15px] left-[30px] w-[5px] h-[5px] bg-color-primary-D rounded-full"></div>
            <div className="absolute bottom-[20px] left-[40px] w-[5px] h-[5px] bg-color-primary-D rounded-full"></div>
            <span
              className={`absolute font-font_primary_A text-[16px] font-medium text-[#000000] right-[-120px]  top-1/2 -translate-y-1/2 `}
            >
              {pieceItems.find((item) => item.id === animIndex)?.pieceName}
            </span>
            {pieceItems.map((item) => (
              <MainPiecesBox
                key={item.id}
                id={item.id}
                src={item.src}
                svg={item.svg}
                top={item.top}
                right={item.right}
                opacity={item.opacity}
                visibility={item.visibility}
                isSelect={item.isSelect}
                clN={item.className}
                animIndex={animIndex}
                setAnimIndex={setAnimIndex}
                termsIndex={termsIndex}
              />
            ))}
          </div>
        </div>
      </div>
      <MainSecTwoMobile />
    </div>
  );
}
